import { render, staticRenderFns } from "./collapse.vue?vue&type=template&id=a75e7e50&scoped=true"
import script from "./collapse.vue?vue&type=script&lang=ts"
export * from "./collapse.vue?vue&type=script&lang=ts"
import style0 from "./collapse.vue?vue&type=style&index=0&id=a75e7e50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a75e7e50",
  null
  
)

export default component.exports